import { withBemMod } from '@bem-react/core';
import { compose } from '@bem-react/core';
import { Icon as IconBase } from '@yandex-lego/components/Icon/desktop';
import React, { FC, ReactElement } from 'react';
import {
    withTypeMobile as withIconTypeMobile,
    withSizeM as withIconSizeM,
} from 'components/Icon';

import { cnMethodSelector } from '../../MethodSelector';
import { MethodSelectorOptionContentProps } from '../MethodSelector-OptionContent.interface';
import { getMethods } from '../../MethodSelector.util';

export interface WithTypeMobile {
    type?: 'mobile';
}

const Icon = compose(
    withIconSizeM,
    withIconTypeMobile,
)(IconBase);

const methods = getMethods();

export const withTypeMobile = withBemMod<WithTypeMobile, MethodSelectorOptionContentProps>(
    cnMethodSelector('OptionContent'),
    { type: 'mobile' },
    (OptionContent): FC<WithTypeMobile & MethodSelectorOptionContentProps> => (
        (props: WithTypeMobile & MethodSelectorOptionContentProps): ReactElement => {
            const {
                method,
            } = props;

            return (
                <OptionContent {...props}>
                    <Icon
                        type="mobile"
                        size="m"
                    />
                    <span className={cnMethodSelector('OptionContentText')}>
                        {methods[method]}
                    </span>
                </OptionContent>
            );
        }
    ),
);
